import { render, staticRenderFns } from "./OffersPage.vue?vue&type=template&id=2c18c8e5&scoped=true&"
import script from "./OffersPage.vue?vue&type=script&lang=js&"
export * from "./OffersPage.vue?vue&type=script&lang=js&"
import style0 from "./OffersPage.vue?vue&type=style&index=0&id=2c18c8e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18c8e5",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/offers_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Foffers%2FOffersPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports